import { render, staticRenderFns } from "./BTimezones.vue?vue&type=template&id=fba63d28&scoped=true"
import script from "./BTimezones.vue?vue&type=script&lang=js"
export * from "./BTimezones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba63d28",
  null
  
)

export default component.exports